import "./App.css";

import { Container } from "semantic-ui-react";
import MainContainer from "./components/MainContainer";
import React from "react";

function App() {
  return (
    <Container>
      <MainContainer />
    </Container>
  );
}

export default App;
